// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "p\u0159id\u00e1n\u00ed diskuze";
